// /trends — every analysis surface: body, running, padel, strength.

import { createFileRoute } from '@tanstack/react-router';
import { DesktopPage } from '../components/ledger/DesktopPage';
import { TrendsPage, TrendsScreen } from '../components/ledger/TrendsPage';
import { useIsDesktop } from '../lib/useMediaQuery';

function TrendsRoute() {
  const desktop = useIsDesktop();
  if (!desktop) return <TrendsScreen />;
  return (
    <DesktopPage inspector="coach">
      <TrendsPage />
    </DesktopPage>
  );
}

export const Route = createFileRoute('/trends')({ component: TrendsRoute });
